/**
 * This file is generated by the @wordpress/terrazzo-plugin-inline-alias-values plugin.
 * Do not edit this file directly.
 */

export default {
	'primary-bgFill1': [ 'bg-interactive-brand-strong' ],
	'primary-fgFill': [
		'fg-interactive-brand-strong',
		'fg-interactive-brand-strong-active',
	],
	'primary-bgFill2': [ 'bg-interactive-brand-strong-active' ],
	'primary-surface2': [ 'bg-interactive-brand-active' ],
	'primary-surface4': [ 'bg-interactive-brand-weak-active' ],
	'primary-fgSurface3': [
		'fg-interactive-brand',
		'fg-interactive-brand-active',
	],
	'primary-stroke3': [
		'bg-thumb-brand',
		'bg-thumb-brand-active',
		'stroke-focus-brand',
		'stroke-interactive-brand',
		'stroke-surface-brand-strong',
	],
	'primary-stroke4': [ 'stroke-interactive-brand-active' ],
	'primary-stroke1': [ 'stroke-surface-brand' ],
	'primary-surface1': [ 'bg-surface-brand' ],
	'info-surface2': [ 'bg-surface-info-weak' ],
	'info-surface4': [ 'bg-surface-info' ],
	'info-fgSurface4': [ 'fg-content-info' ],
	'info-fgSurface3': [ 'fg-content-info-weak' ],
	'info-stroke3': [ 'stroke-surface-info-strong' ],
	'info-stroke1': [ 'stroke-surface-info' ],
	'success-surface2': [ 'bg-surface-success-weak' ],
	'success-surface4': [ 'bg-surface-success' ],
	'success-fgSurface4': [ 'fg-content-success' ],
	'success-fgSurface3': [ 'fg-content-success-weak' ],
	'success-stroke3': [ 'stroke-surface-success-strong' ],
	'success-stroke1': [ 'stroke-surface-success' ],
	'warning-surface2': [ 'bg-surface-warning-weak' ],
	'warning-surface4': [ 'bg-surface-warning' ],
	'warning-fgSurface4': [ 'fg-content-warning' ],
	'warning-fgSurface3': [ 'fg-content-warning-weak' ],
	'warning-stroke3': [ 'stroke-surface-warning-strong' ],
	'warning-stroke1': [ 'stroke-surface-warning' ],
	'error-bgFill1': [ 'bg-interactive-error-strong' ],
	'error-fgFill': [
		'fg-interactive-error-strong',
		'fg-interactive-error-strong-active',
	],
	'error-bgFill2': [ 'bg-interactive-error-strong-active' ],
	'error-surface2': [
		'bg-interactive-error-active',
		'bg-surface-error-weak',
	],
	'error-surface4': [
		'bg-interactive-error-weak-active',
		'bg-surface-error',
	],
	'error-fgSurface4': [ 'fg-content-error' ],
	'error-fgSurface3': [
		'fg-content-error-weak',
		'fg-interactive-error',
		'fg-interactive-error-active',
	],
	'error-stroke3': [
		'stroke-interactive-error',
		'stroke-interactive-error-strong',
		'stroke-surface-error-strong',
	],
	'error-stroke4': [ 'stroke-interactive-error-active' ],
	'error-stroke1': [ 'stroke-surface-error' ],
	'bg-surface2': [ 'bg-surface-neutral' ],
	'bg-surface6': [
		'bg-interactive-brand-strong-disabled',
		'bg-interactive-error-strong-disabled',
		'bg-interactive-neutral-strong-disabled',
	],
	'bg-surface5': [
		'bg-interactive-brand-disabled',
		'bg-interactive-brand-weak-disabled',
		'bg-interactive-error-disabled',
		'bg-interactive-error-weak-disabled',
		'bg-interactive-neutral-disabled',
		'bg-interactive-neutral-weak-disabled',
	],
	'bg-surface4': [
		'bg-interactive-neutral-active',
		'bg-interactive-neutral-weak-active',
	],
	'bg-surface3': [ 'bg-surface-neutral-strong' ],
	'bg-fgSurface4': [
		'fg-content-neutral',
		'fg-interactive-neutral',
		'fg-interactive-neutral-active',
	],
	'bg-fgSurface3': [
		'fg-content-neutral-weak',
		'fg-interactive-brand-strong-disabled',
		'fg-interactive-error-strong-disabled',
		'fg-interactive-neutral-strong-disabled',
		'fg-interactive-neutral-weak',
	],
	'bg-fgSurface2': [
		'fg-interactive-brand-disabled',
		'fg-interactive-error-disabled',
		'fg-interactive-neutral-disabled',
		'fg-interactive-neutral-weak-disabled',
	],
	'bg-stroke3': [
		'bg-thumb-neutral-weak',
		'stroke-interactive-neutral',
		'stroke-surface-neutral-strong',
	],
	'bg-stroke4': [
		'bg-thumb-neutral-weak-active',
		'stroke-interactive-neutral-active',
		'stroke-interactive-neutral-strong',
	],
	'bg-stroke2': [
		'bg-thumb-brand-disabled',
		'bg-track-neutral',
		'stroke-interactive-neutral-disabled',
		'stroke-surface-neutral',
	],
	'bg-stroke1': [ 'bg-track-neutral-weak', 'stroke-surface-neutral-weak' ],
	'bg-bgFillInverted2': [ 'bg-interactive-neutral-strong-active' ],
	'bg-bgFillInverted1': [ 'bg-interactive-neutral-strong' ],
	'bg-fgFillInverted': [
		'fg-interactive-neutral-strong',
		'fg-interactive-neutral-strong-active',
	],
	'bg-surface1': [ 'bg-surface-neutral-weak' ],
	'caution-surface2': [ 'bg-surface-caution-weak' ],
	'caution-surface4': [ 'bg-surface-caution' ],
	'caution-fgSurface4': [ 'fg-content-caution' ],
	'caution-fgSurface3': [ 'fg-content-caution-weak' ],
} as Record< string, string[] >;
